import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { Download, Trash2, AlertTriangle } from 'lucide-react';
import api from '../utils/api';
import { useAuth } from '../context/AuthContext';

const API_URL = process.env.REACT_APP_API_URL || '/api';

// Export RGPD + suppression définitive du compte entreprise.
export default function DangerZone() {
  const { user, logout } = useAuth();
  const [showDelete, setShowDelete] = useState(false);
  const [form, setForm] = useState({ password: '', confirm: '' });
  const [busy, setBusy] = useState(false);

  if (user?.role !== 'ADMIN' && user?.role !== 'SUPER_ADMIN') return null;

  const exportData = async () => {
    try {
      // Téléchargement authentifié : on passe par fetch + blob.
      const token = localStorage.getItem('token');
      const res = await fetch(`${API_URL}/users/company/export`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!res.ok) throw new Error();
      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `export-jalonne-${new Date().toISOString().slice(0, 10)}.zip`;
      a.click();
      URL.revokeObjectURL(url);
      toast.success('Export téléchargé');
    } catch {
      toast.error('Erreur lors de l\'export');
    }
  };

  const deleteCompany = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.delete('/users/company', { data: form });
      toast.success('Entreprise supprimée. Au revoir !');
      await logout();
      window.location.href = '/';
    } catch (err) {
      toast.error(err.response?.data?.error || 'Erreur');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="card" style={{ border: '1px solid #fecaca' }}>
      <h3 style={{ color: '#991b1b', display: 'flex', alignItems: 'center', gap: 8, marginBottom: 10 }}>
        <AlertTriangle size={17} /> Données & suppression
      </h3>

      <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', alignItems: 'center' }}>
        <button className="btn btn-sm" onClick={exportData}>
          <Download size={13} /> Exporter toutes mes données (ZIP)
        </button>
        {!showDelete && (
          <button className="btn btn-danger btn-sm" onClick={() => setShowDelete(true)}>
            <Trash2 size={13} /> Supprimer définitivement l'entreprise
          </button>
        )}
      </div>

      {showDelete && (
        <form onSubmit={deleteCompany} style={{ marginTop: 14, background: '#fef2f2', borderRadius: 8, padding: 14 }}>
          <p style={{ fontSize: '0.85rem', color: '#991b1b', lineHeight: 1.6, marginBottom: 10 }}>
            <strong>Action irréversible.</strong> Tous les chantiers, photos, intervenants,
            membres et réglages seront définitivement supprimés, et vos pages publiques
            cesseront de fonctionner. <strong>Exportez vos données avant.</strong>
          </p>
          <div className="form-row">
            <div className="form-group">
              <label>Votre mot de passe</label>
              <input type="password" required value={form.password}
                onChange={e => setForm({ ...form, password: e.target.value })} />
            </div>
            <div className="form-group">
              <label>Tapez SUPPRIMER</label>
              <input required value={form.confirm} placeholder="SUPPRIMER"
                onChange={e => setForm({ ...form, confirm: e.target.value })} />
            </div>
          </div>
          <div style={{ display: 'flex', gap: 8 }}>
            <button className="btn btn-danger btn-sm" disabled={busy || form.confirm !== 'SUPPRIMER'}>
              {busy ? 'Suppression...' : 'Supprimer définitivement'}
            </button>
            <button type="button" className="btn btn-sm" onClick={() => setShowDelete(false)}>Annuler</button>
          </div>
        </form>
      )}
    </div>
  );
}
